import name from './name'

const selectSliceData = state => state[name]

const selectPlaylist = state => selectSliceData(state)

const selectContentUrls = state =>
  selectSliceData(state).content.map(({ locationId }) => locationId)

const selectBack = state => selectSliceData(state).back || {}

const selectContentCount = state => selectSliceData(state).content?.length ?? 0

export { selectPlaylist, selectContentUrls, selectBack, selectContentCount }
